<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      ref="searchBox"
      @sub="sub"
      @reset="reset"
      title="筛选"
      permpisionsQuery=""
    >
    </qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>
<script>
import TableBox from './tableBox';
import {
  // getEnumList,
  getCarTypeList,
  getDepartmentAllList,
} from 'api';
import {getOrgOptions} from '@qx/utils';
import {mapState} from 'vuex';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        vehicleStatusTypeOptions: [],
        orgIdOptions: [],
        form: [
          {
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          {
            label: '证照类型',
            value: 'certificatesInsuranceType',
            type: 'select',
            placeholder: '证照类型',
            default: '-1',
            options: [
              {
                label: '全部',
                value: '-1',
              },
              {
                label: '行驶证年审',
                value: '1',
              },
              {
                label: '营运证年审',
                value: '2',
              },
            ],
          },
          {
            label: '到期时间',
            value: 'insuranceDate',
            type: 'date',
            placeholder: '到期时间',
            attr: {
              type: 'daterange',
            },
          },
          {
            label: '司机',
            value: 'userName',
            type: 'input',
            placeholder: '请输入司机',
          },
          {
            label: '牌照类型',
            value: 'licenceType',
            type: 'select',
            placeholder: '请选择牌照类型',
            default: '-1',
            options: [
              {
                label: '全部',
                value: '-1',
              }, {
                label: '整车',
                value: '1',
              }, {
                label: '牵引车',
                value: '2',
              }, {
                label: '挂车',
                value: '3',
              },
            ],
          },
          {
            label: '车辆类型',
            value: 'vehicleStatusType',
            type: 'cascader',
            normal: true,
            default: [],
          },
          {
            label: '是否有效',
            value: 'isEffective',
            type: 'select',
            placeholder: '请选择是否有效',
            default: '-1',
            options: [
              {
                label: '全部',
                value: '-1',
              },
              {
                label: '是',
                value: '1',
              },
              {
                label: '否',
                value: '2',
              },
            ],
          },
          {
            label: '归属部门',
            value: 'orgId',
            type: 'select',
            placeholder: '请选择归属部门',
            default: '-1',
          },
          {
            label: '归属员工',
            value: 'relUserName',
            type: 'input',
            placeholder: '请输入归属员工',
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {
    sub (searchBoxData) {
      if (searchBoxData.insuranceDate && searchBoxData.insuranceDate.length) {
        searchBoxData.insuranceEndDate = this.formatDate(searchBoxData.insuranceDate[0]);
        searchBoxData.insuranceEndDateEnd = this.formatDate(searchBoxData.insuranceDate[1]);
      }
      if (searchBoxData.vehicleStatusType && searchBoxData.vehicleStatusType.length) {
        searchBoxData.vehicleStatus = searchBoxData.vehicleStatusType[0];
        searchBoxData.vehicleLength = searchBoxData.vehicleStatusType[1];
      } else {
        searchBoxData.vehicleStatus = '-1';
        searchBoxData.vehicleLength = '-1';
      }
      searchBoxData.flg = '2';
      delete searchBoxData.insuranceDate;
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
    reset () {
      this.$refs.searchBox.setVal('insuranceDate', ['', '']);
    },
    // setDefalutDate () {
    //   const firstdate = new Date(new Date().getFullYear(), new Date().getMonth() - 2, 1);
    //   this.setFormAttrVal({
    //     form: this.searchBoxData,
    //     attr: 'default',
    //     value: [this.formatDate(firstdate), ''],
    //     names: ['insuranceDate'],
    //   });
    // },
  },
  async created () {
    // this.setDefalutDate();
    const vehicleStatusEnumsList = await getCarTypeList();
    const orgIdOptions = await getDepartmentAllList({ isArchive: true});
    this.searchBoxData.vehicleStatusTypeOptions = vehicleStatusEnumsList;
    this.searchBoxData.orgIdOptions = [
      {
        label: '全部',
        value: '-1',
      },
      ...orgIdOptions,
    ];
  },
};
</script>
<style lang="scss" scoped>
</style>
